<template>
  <div id="app">
    <router-view/>
    <modals-container></modals-container>
  </div>
</template>

<script>
import { ModalsContainer } from 'vue-final-modal'

export default {
  name: 'App',
  components: {ModalsContainer},
  created () {
    console.log(this.$logger)
  }
}
</script>

<style>
  @import './assets/css/bootstrap.min.css';
  @import './assets/font-awesome-4.7.0/css/font-awesome.min.css';
  @import './assets/css/fonts.css';
  @import './assets/css/style.css';
  @import './assets/css/media.css';
</style>



// WEBPACK FOOTER //
// src/App.vue